// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { castToFloat } from 'helpers/reduxFormFunctions'

const validateModulationPowerRange = (m, error) => {
  const power = castToFloat(m.power)
  const txPowerMax = castToFloat(m.txPowerMax)
  const txPowerMin = castToFloat(m.txPowerMin)

  // if txPowerMin is defined, and the power is less than that, it's invalid
  if (txPowerMin !== null && power < txPowerMin) {
    error.modulations.push({ power: `Cannot be less than ${txPowerMin}` })

  // else, if the power is greater than this modulation's txPowerMax + 3, it's invalid
  } else if (power > (txPowerMax + 3)) {
    error.modulations.push({ power: `Cannot be greater than ${txPowerMax + 3}` })

  // redux form needs validation/error objects to match indexes of their respective field arrays
  } else {
    error.modulations.push({})
  }
}

export default validateModulationPowerRange
